import PropTypes from 'prop-types';
import Link from 'next/link';

import { useAppSelector } from '@/redux';
import { formatUrl, getHrefForCategLink } from '@/utils/linkUtils';

import TagList from '@/components/common/TagList';
import Tag from '@/components/common/Tag';

import styles from './QuickMenu.module.scss';

export const QuickMenu = ({ t, categLinks, isMobile }) => {
  const { storeConf } = useAppSelector(({ root }) => root);

  return categLinks?.length > 0 ? (
    <div className={styles.container} data-test-id="quick-menu">
      <TagList t={t} displayShowMore={!isMobile} displayScrollBar={isMobile}>
        {categLinks.map((link, i) => (
          <Link
            as={formatUrl(link.url, link.isSpirit, storeConf)}
            className={styles.content}
            data-test-id="link"
            href={getHrefForCategLink(link.url, link.id, link.isSpirit)}
            key={i}
            passHref
          >
            <Tag clickable>
              {link.name}
            </Tag>
          </Link>
        ))}
      </TagList>
    </div>
  ) : null;
};

QuickMenu.propTypes = {
  /** Translate function */
  t: PropTypes.func.isRequired,
  /** Array of links  */
  categLinks: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string,
    name: PropTypes.string
  })),
  /** Mobile render */
  isMobile: PropTypes.bool.isRequired
};

export default QuickMenu;
